"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vueSvgicon = _interopRequireDefault(require("vue-svgicon"));
/* eslint-disable */
/* tslint:disable */
// @ts-ignore

_vueSvgicon.default.register({
  'achievement': {
    width: 800,
    height: 800,
    viewBox: '0 0 455 455',
    data: '<path pid="0" d="M332.707 322.265l-57.739 41.588-47.473-34.194-47.468 34.195-57.737-41.592L0 454.397h455z"/><path pid="1" d="M212.5 224.789l-69.68 75.289 37.207 26.803 47.466-34.195 47.475 34.196 37.207-26.801-69.675-75.28V.603H104.54V101.86H212.5z"/>'
  }
});